(function () {
  'use strict';

  angular
    .module('directive.video-player', [])

    /* @ngInject */
    .factory('VideoPlayerService', ["$timeout", function ($timeout) {
      var load,
        queue = [];

      var service = {
        add: add
      };
      return service;

      ////////////

      function add(element, scope) {
        if (angular.isUndefined($.fn.pPlayer)) {
          queue.push({ element: element, scope: scope });
          if (!load) {
            load = true;
            $.ajax({
              url: '/js/jquery.pplayer.min.js',
              dataType: 'script',
              cache: true,
              success: function () {
                start();
              }
            });
          }
        } else {
          init(element, scope);
        }
      }

      function start() {
        _.each(queue, function (item) {
          init(item.element, item.scope);
        });
      }

      function init(element, scope) {
        var id = getYouTubeIdFromUrl(scope.url);
        element.children('.player').pPlayer({
          youtubeVideoId: id,
          autoplay: scope.autoplay ? 1 : 0,
          adapter: 'Youtube',
          showinfo: 0,
          features: [ 'playpause', 'progress', 'timer', 'quality', 'mute', 'fullscreen' ],
          resizeVideo: false,
          afterInit: function () {
            $timeout(function () {
              scope.showLoader = false;
            });
            var $mainVideo = element.parent().parent();
            if ($mainVideo.hasClass('main-video')) {
              $mainVideo.children('.inner').addClass('in');
            }
          }
        });
      }

      function getYouTubeIdFromUrl(youtubeUrl) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
        var match = youtubeUrl.match(regExp);
        if (match && match[2].length === 11) {
          return match[2];
        }
        return false;
      }
    }])

    /* @ngInject */
    .directive('videoPlayer', ["VideoPlayerService", function (VideoPlayerService) {
      return {
        restrict: 'E',
        scope: {
          url: '@',
          autoplay: '<'
        },
        templateUrl: 'directive.video-player.tpl',
        link: function (scope, element) {
          scope.showLoader = true;
          VideoPlayerService.add(element, scope);
        }
      };
    }]);

})();
